import React, { useEffect, useRef, useState } from "react";
import classNames from "classnames";
import { ModulePagerProps } from ".";

const ModulePagerMobile/* : React.FC<ModulePagerProps> */ = <T,>({ pager, items, className, renderItem, ...rest }: React.PropsWithChildren<ModulePagerProps<T>>) => {
   const ref = useRef<HTMLDivElement | null>(null);

   const [renderProps, setRenderProps] = useState({ startIndex: 0, endIndex: 0 });
   const itemTranslateX = renderProps.startIndex * (pager.itemWidth + pager.gapWidth);

   const recalculateRenderProps = () => {
      let scrollLeft = ref.current?.scrollLeft ?? 0;
      if (scrollLeft < 0){
         scrollLeft = 0;
      }
      const wrapperWidth = ref.current?.clientWidth ?? 0;

      const startIndex = Math.floor(scrollLeft / (pager.itemWidth + pager.gapWidth));
      const endIndex = Math.ceil((scrollLeft + wrapperWidth) / (pager.itemWidth + pager.gapWidth));

      setRenderProps({ startIndex, endIndex });
   };


   useEffect(() => {
      const listener = () => {
         window.requestAnimationFrame(recalculateRenderProps);
      }
      ref.current?.addEventListener("scroll", listener);

      window.requestAnimationFrame(recalculateRenderProps);

      return () => {
         ref.current?.removeEventListener("scroll", listener);
      }
   }, [items]);

   return <div
      {...rest}
      className={classNames("module-pager-mobile", className)}
      ref={(node) => { pager.setPagerElement(node); ref.current = node; }}
   >
      <div className="module-pager-mobile-outer" style={{
         width: pager.renderProps.wrapperWidth
      }}>
         <div
            className="module-pager-mobile-inner"
            style={{
               gap: pager.gapWidth,
               transform: `translateX(${itemTranslateX}px)`
            }}>
            {
               items
                  .slice(renderProps.startIndex, renderProps.endIndex)
                  .map(item => renderItem(item, { width: pager.itemWidth }))
            }
         </div>
      </div>

   </div>
}

export default ModulePagerMobile;